import React, { useState, useEffect } from 'react';

const Abstracts = ({}) => {

  // const [data, setData] = useState(null);

  useEffect(() => {
  }, [])

  return (
    <div className="admin-channel-design">
      holds Abstracts
    </div>
  )
}

export default Abstracts;